var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeads(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9501 6.50005L11.1001 0.900051C10.4501 0.400051 9.5501 0.400052 8.9001 0.850052L1.1001 6.20005C0.750104 6.45005 0.650103 6.90005 0.900103 7.25005C1.1501 7.60005 1.6001 7.70005 1.9501 7.45005L3.0001 6.70005V12.8501C3.0001 15.1501 4.8501 17.0001 7.1501 17.0001H12.8501C15.1501 17.0001 17.0001 15.1501 17.0001 12.8501V6.95005L18.0501 7.70005C18.2001 7.80005 18.3501 7.85005 18.5001 7.85005C18.7501 7.85005 18.9501 7.75005 19.1001 7.55005C19.3501 7.20005 19.2501 6.75005 18.9501 6.50005ZM15.5001 12.8501C15.5001 14.3001 14.3001 15.5001 12.8501 15.5001H7.1501C5.7001 15.5001 4.5001 14.3001 4.5001 12.8501V5.65005L9.8001 2.05005C9.9001 1.95005 10.0501 1.95005 10.2001 2.05005L15.5001 5.85005V12.8501Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeads);
export default __webpack_public_path__ + "static/media/leads.7270d2e56759797ed6e7c48c573f9f32.svg";
export { ForwardRef as ReactComponent };